import React from "react";
import { FaqMain, FaqSection, FaqWrapper } from "../components/Faq/Faq.styled";

export const PrivacyPolicy = () => {
  return (
    <FaqWrapper>
      <div className='container'>
        <FaqMain>
          <h2>Tontake Privacy Policy</h2>
          <span>June 1, 2022</span>
          <FaqSection>
            <p>
              Tontake (“Tontake,” “we”, “us”, or “our”) is committed to protecting your privacy. We have prepared this Privacy Policy to describe to
              you our practices regarding the Personal Data (as defined below) we collect, use, and share in connection with the OpenSea website,
              mobile app, and other software provided on or in connection with our services, as described in our Terms of Service (collectively, the
              “Service”).{" "}
            </p>

            <p>
              “NFT” in this Privacy Policy means a non-fungible token or similar digital item implemented on a blockchain (such as the Ethereum
              blockchain), which uses smart contracts to link to or otherwise be associated with certain content or data.
            </p>

            <p>
              <strong>Types of Data We Collect.</strong> “Personal Data” means data that allows someone to identify you individually, including, for
              example, your name, email address, as well as any other non-public information about you that is associated with or linked to any of the
              foregoing. “Anonymous Data” means data, including aggregated and de-identified data, that is not associated with or linked to your
              Personal Data; Anonymous Data does not, by itself, permit the identification of individual persons. We collect Personal Data and
              Anonymous Data as described below.
            </p>

            <p>
              <strong>Information You Provide Us.</strong>
            </p>
            <p>
              <ul>
                <li>
                  When you use our Service, update your account profile, or contact us, we may collect Personal Data from you, such as email address,
                  first and last name, user name, and other information you provide. We also collect your blockchain address, which may become
                  associated with Personal Data when you use our Service.
                </li>

                <li>
                  Our Service lets you store preferences like how your content is displayed, notification settings, and favorites. We may associate
                  these choices with your ID, browser, or mobile device.
                </li>

                <li>
                  If you provide us with feedback or contact us, we will collect your name and contact information, as well as any other content
                  included in the message.
                </li>

                <li>
                  We may also collect Personal Data at other points in our Service where you voluntarily provide it or where we state that Personal
                  Data is being collected.
                </li>
              </ul>
            </p>

            <p>
              <strong>Information Collected from Third-Party Companies.</strong> We may receive Personal and/or Anonymous Data about you from
              companies that offer their products and/or services for use in conjunction with our Service or whose products and/or services may be
              linked from our Service. For example, third-party wallet providers provide us with your blockchain address and certain other information
              you choose to share with those wallets providers. We may add this to the data we have already collected from or about you through our
              Service.
            </p>

            <p>
              <strong>Public Information Observed from Blockchains. </strong>We collect data from activity that is publicly visible and/or accessible
              on blockchains. This may include blockchain addresses and information regarding purchases, sales, or transfers of NFTs, which may then
              be associated with other data you have provided to us.
            </p>

            <p>
              <strong>Use of Your Personal Data.</strong>
            </p>

            <p>
              We process your Personal Data to run our business, provide the Service, personalize your experience on the Service, and improve the
              Service. Specifically, we use your Personal Data to:
            </p>

            <p>
              <ul>
                <li>facilitate the creation of and secure your account;</li>

                <li>identify you as a user in our system;</li>

                <li>
                  provide you with our Service, including, but not limited to, helping you view, explore, and create NFTs using our tools and, at your
                  own discretion, connect directly with others to purchase, sell, or transfer NFTs on public blockchains;
                </li>

                <li>
                  improve the administration of our Service and quality of experience when you interact with our Service, including, but not limited
                  to, by analyzing how you and other users find and interact with the Service;
                </li>

                <li>provide customer support and respond to your requests and inquiries;</li>

                <li>investigate and address conduct that may violate our Terms of Service;</li>

                <li>detect, prevent, and address fraud, violations of our terms or policies, and/or other harmful or unlawful activity;</li>

                <li>
                  display your username next to the NFTs currently or previously accessible in your third-party wallet, and next to NFTs on which you
                  have interacted;
                </li>

                <li>send you a welcome email to verify ownership of the email address provided when your account was created;</li>

                <li>send you administrative notifications, such as security, support, and maintenance advisories;</li>

                <li>send you notifications related to actions on the Service, including notifications of offers on your NFTs;</li>

                <li>send you newsletters, promotional materials, and other notices related to our Services or third parties' goods and services;</li>

                <li>respond to your inquiries related to employment opportunities or other requests;</li>

                <li>
                  comply with applicable laws, cooperate with investigations by law enforcement or other authorities of suspected violations of law,
                  and/or to pursue or defend against legal threats and/or claims; and
                </li>

                <li>act in any other way we may describe when you provide the Personal Data.</li>
              </ul>
            </p>

            <p>
              We may create Anonymous Data records from Personal Data. We use this Anonymous Data to analyze request and usage patterns so that we may
              improve our Services and enhance Service navigation. We reserve the right to use Anonymous Data for any purpose and to disclose
              Anonymous Data to third parties without restriction.
            </p>

            <p>
              <strong>Data Protection.</strong> We care about the security of your information and use physical, administrative, and technological
              safeguards to preserve the integrity and security of information collected through our Service. However, no security system is
              impenetrable and we cannot guarantee the security of our systems. In the event that any information under our custody and control is
              compromised as a result of a breach of security, we will take steps to investigate and remediate the situation and, in accordance with
              applicable laws and regulations, notify those individuals whose information may have been compromised.
            </p>
          </FaqSection>
        </FaqMain>
      </div>
    </FaqWrapper>
  );
};
